import React from 'react';
import logoutSuccess from '@/public/assets/logout-success.png';
import logoutSuccess2x from '@/public/assets/logout-success@2x.png';
import logoutSuccess3x from '@/public/assets/logout-success@3x.png';
import LoginLayout from '../../../../layout/LoginLayout';
import './index.less';

const LogoutSuccess = () => (
    <LoginLayout>
        <div className="logout-success-modal">
            <h1>注销成功</h1>
            <img
                srcSet={`${logoutSuccess},
                            ${logoutSuccess2x} 2x,
                            ${logoutSuccess3x} 3x,`}
                src={logoutSuccess}
                alt="logout-success"
            />
            <p>您已经成功退出CAS系统，谢谢使用！出于安全考虑，请关闭您的浏览器。</p>
        </div>
    </LoginLayout>
);

export default LogoutSuccess;
